<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01">
<a id="page08"></a>
<a id="page09"></a>
<div class="chapterHead">
<h2 class="chapterTitle"> </h2></div>
<div class="chapterBody">
<p class="chapterOpenerText1"><em class="italic">Ernesto “Che” Guevara, born in Buenos Aires in 1928, was reportedly killed while leading a revolution in Bolivia in 1967. An asthmatic licensed physician, Che joined the Castro brothers and seventy-nine other revolutionaries on the</em> Granma, <em class="italic">the boat that landed on Cuban shores in 1956, and, as a</em> comandante, <em class="italic">played a key role in overthrowing the Batista government on New Year’s Day, 1959.</em></p>
<p class="para"><em class="italic">“Che” is an Argentinian colloquialism for “pal.”</em></p>
<a id="page10"></a>
<a id="page11"></a>
<a id="page12"></a>
<a id="page13"></a>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front.vue?5d994b5e